export interface BackgroundRemoverState {
  processing?: boolean;
  manualActive?: boolean;
  originalSrc?: string;
  /** The layer's print source (`large`) before removal, restored with the original. */
  originalLarge?: string;
  processedSrc?: string;
  processedPath?: string;
  previewSrc?: string;
  statusText?: string;
  error?: string;
  brushSize?: number;
}

export interface BackgroundRemoverItem {
  id?: string;
  type?: string;
  src?: string;
  thumb?: string;
  file?: string;
  file_name?: string;
  backgroundRemover?: BackgroundRemoverState;
  [key: string]: unknown;
}

export interface UploadedMedia {
  name: string;
  url: string;
  path: string;
  /** Full-size file for print output; falls back to `url`. */
  large?: string;
  thumb?: string;
}

export const STATE_KEY = 'backgroundRemover';
export const DEFAULT_BRUSH_SIZE = 28;
